// extracted by mini-css-extract-plugin
export default {"container":"Up-z","heading":"Vp-z","text":"Wp-z","info":"Xp-z","link":"Yp-z","fullMaxWidth":"Zp-z"};